<template>
  <a-modal :title="leaveTitle || $t('message')" v-model="isShow" @ok="submit" width="650px" :confirmLoading="btnLoading" :okText="$t('OK')" :cancelText="$t('CANCEL')">
    <formMessage ref="formMessage" @isShow="setIsShow" @btnLoading="setBtnLoading" :isCloseWindow="true"></formMessage>
  </a-modal>
</template>
<script>
  import formMessage from  './form-message'
  import { mapState } from 'vuex'
  export default {
    components: {formMessage},
    computed: {
      ...mapState({
        leaveTitle: 'leaveTitle'
      })
    },
    data () {
      return {
        isShow: false,
        btnLoading: false,
      }
    },
    methods: {
      setBtnLoading (val) {
        this.btnLoading = val
      },
      setIsShow (val) {
        this.isShow = val
      },
      show () {
        this.isShow = true
      },
      submit () {
        this.$refs.formMessage.submit()
      },
    },
    created () {

    }
  }
</script>
